import React from "react";

const MainNeedHelp = () => {
  return (
    <>
      <div className="q-order-main-page">
        <div className="q-add-categories-section">
          <div className="q-add-categories-section-header">
            <span>
              <span>Need Help</span>
            </span>
          </div>
          <div className="my-10">
          
              <div className="px-4 my-5 text-xl">
                <p>For any assistance please reach us on</p>
              </div>
              <div className="px-4 my-5 text-sm">
               <p>Email :- support@quickvee.com </p> 
              <p>Support number :- 925-271-9711 /
                925-452-6016 / 925-203-1129</p>  
              </div>
            
          </div>
        </div>
      </div>
    </>
  );
};

export default MainNeedHelp;
